/**
 * Hook up live formatting to phone input fields.
 *
 * NANP-only (US + Canada) — see app/Libraries/PhoneUtils for the canonical format definition.
 * The 10-digit cap is intentional. If international support is ever needed, this library
 * looks more versatile: https://www.npmjs.com/package/libphonenumber-js
 */

import { groupNanpDigits } from '../../../app/Libraries/PhoneUtils';

/**
 * Format the input field as a phone number: `XXX-XXX-XXXX` (NANP, dashes only).
 * @param input The phone input field to format
 */
function formatPhoneInput(input: HTMLInputElement) {
  let cleaned = input.value.replace(/\D+/g, '');

  // Drop a leading NA country code so prefilled values like "+15551234567" or "1-555-..."
  // format correctly. Safe per NANP: valid 10-digit area codes can never start with 0 or 1,
  // so an 11-digit string starting with 1 is unambiguously a country-code prefix.
  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    cleaned = cleaned.substring(1);
  }

  if (cleaned.length > 10) {
    cleaned = cleaned.substring(0, 10);
  }

  input.value = groupNanpDigits(cleaned);
}

document.addEventListener('DOMContentLoaded', () => {
  const phoneInputs = document.querySelectorAll('input.js-phone-input');
  phoneInputs.forEach((input) => {
    formatPhoneInput(input as HTMLInputElement);
    input.addEventListener('input', (event) => {
      formatPhoneInput(event.target as HTMLInputElement);
    });
  });
});
